import { useContext } from 'react'

import { AuthContext } from 'auth/auth-provider'

export function useAuth() {
  return useContext(AuthContext)
}
